// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ring-tooltip-ng{max-width:400px;padding:8px;text-align:left}.ring-tooltip-ng__hint-icon{margin-left:8px;color:#b8d1e5;color:var(--ring-icon-color);cursor:pointer;position:relative;top:-2px}.ring-tooltip-ng_open .ring-tooltip-ng__hint-icon{color:#ff008c;color:var(--ring-link-hover-color)}", ""]);
// Exports
module.exports = exports;
